module.exports = "<div class=\"gw-row__item\" gw-partial=\"Item\"></div>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/widgets/layouts/templates/Row.html
// module id = 505
// module chunks = 0